import { Autocomplete, Button, FormControl, Table, IconButton, MenuItem, Select, TableCell, TableHead, TableRow, Typography, TableBody, TablePagination } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ApiDownloadAllAsXlsInImportExportAllocation, ApiImportExportAllocationPoints, ApiImportExportAllocationTable } from '../../../apiService/Core/Apicall.tsx'

function ImportExportAllocations() {
    const [currentDate, setCurrentDate] = useState(new Date())
    const [status, setstatus] = useState<string>('created')
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [allocationTable, setallocationTable] = useState<any>([]);
    const [allocationPoints, setallocationPoints] = useState<any>([]);

    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const tabledata = async () => {
        setallocationTable([])
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}&allocationStatus=${status}&offset=${rowsPerPage * page}&limit=${rowsPerPage}`
            const res = await ApiImportExportAllocationTable(data)
            setallocationTable(res.data)
            setdatalength(res.totalDataCount)


        } catch (error) {
            alert(error)
        }
    }

    const ponitsdata = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            const res = await ApiImportExportAllocationPoints(data)
            setallocationPoints(res.data)

        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        ponitsdata()
        tabledata()
    }, [currentDate, status, rowsPerPage, page])
    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            // setCurrentPage(1) // Reset to first page when changing month
            // handleGetAppliedAllocation(jobMonth, jobYear)
            return newDate
        })
    }
    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            // setCurrentPage(1) // Reset to first page when changing month
            // handleGetAppliedAllocation(jobMonth, jobYear)
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)

        const jobMonth = newDate.getMonth() + 1
        const jobYear = newDate.getFullYear()
        // setCurrentPage(1) // Reset to first page when date changes
        // handleGetAppliedAllocation(jobMonth, jobYear)
    }

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }
    const Status = ()=>{
        switch (status) {
            case 'created':
                return 'Created'
                break;
        
            case 'shopper_applied':
                return 'Shopper Applied'
                break;
        
            case 'approve':
                return 'Approve'
                break;
        
            case 'completed':
                return 'Completed'
                break;
        
            case 'rejected':
                return 'Rejected'
                break;
        
            case 'hold':
                return 'Hold'
                break;
        
            case 'recheck':
                return 'Recheck'
                break;
        
            case 'applied':
                return 'Applied'
                break;
        
            case 'cancelled':
                return 'Cancel'
                break;
        
            default:
                return "Not Found"
                break;
        }
    }
    const handleDownloadAllAsXls = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            const res = await ApiDownloadAllAsXlsInImportExportAllocation(data);
            console.log("Trend Data Response", res)

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `importExportAllAllocation.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    } 
    const handleDownloadAsXls = async () => {
        try {
            const data = `?jobMonth=${currentDate.getMonth() + 1}&jobYear=${currentDate.getFullYear()}`
            const res = await ApiDownloadAllAsXlsInImportExportAllocation(data);
            console.log("Trend Data Response", res)

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `importExportAllAllocation.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    } 
    return (
        <div style={{ backgroundColor: 'white', padding: "20px !important", overflow:'hidden' }}>
            <h2 className='text-center' style={{ fontWeight: '600' }}> Import Export Allocations</h2>
            <Box className='d-flex px-2 mt-4 extra align-items-center justify-content-between'>
                <FormControl size="small" sx={{ width: 200 }}>
                    <label htmlFor="status" className='mb-0 pl-1' style={{ fontSize: '12px' }}>Status</label>
                    <Select value={status} id='status' onChange={(e) => { setstatus(e.target.value) }}>
                        <MenuItem value="created">Created</MenuItem>
                        <MenuItem value="shopper_applied">Shopper Applied</MenuItem>
                        <MenuItem value="approve">Approve</MenuItem>
                        <MenuItem value="completed">Completed</MenuItem>
                        <MenuItem value="rejected">Rejected</MenuItem>
                        <MenuItem value="hold">Hold</MenuItem>
                        <MenuItem value="recheck">Recheck</MenuItem>
                        <MenuItem value="applied">Applied</MenuItem>
                        <MenuItem value="cancelled">Cancel</MenuItem>
                    </Select>
                </FormControl>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginBottom: "70px",
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            value={formatDate(currentDate)}
                            onChange={handleDateChange}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
            </Box>

            <Box className='d-flex mt-4 mx-2 extra align-items-center justify-content-between' gap={2}>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    DOWNLOAD AS PDF
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                // onClick={() => handleDownloadAsXls(shopperApplied, "approved")}
                >
                    DOWNLOAD AS XLS
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    Roster Master
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                onClick={() => handleDownloadAllAsXls()}
                >
                    DOWNLOAD ALL AS XLS
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    Roster
                </Button>
                <Button
                    fullWidth
                    sx={{ color: 'white' }}
                    className="action-button  action-button--approve table-row-background"
                // onClick={() => handleUpdateAppliedAllocation(shopperApplied, "approved")}
                >
                    Orphan
                </Button>

            </Box>
            <Box className='p-2 mx-2 text-light my-3' borderRadius='5px' bgcolor={'#7a7d52'}>
                <Typography fontWeight='bold' variant='h6'>Total Reports: {(Number(allocationPoints?.MM?.totalReports)+ Number(allocationPoints?.ALDI?.totalReports)+Number(allocationPoints?.TRANSPORT?.totalReports)+Number(allocationPoints?.BLOOMS?.totalReports))}</Typography>
            </Box>
            <Box className='mx-2'>
                <Table>
                    <TableHead sx={{ bgcolor: "#7a7d52"}}>
                        <TableRow>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Site name</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Total Jobs</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Allocated</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Pending Approval</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Orphan</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Completed</TableCell>
                            <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder'}}>Pending</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                           <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder',  bgcolor: "#7a7d52"}}>ALDI</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.completed}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.ALDI?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                           <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder',  bgcolor: "#7a7d52"}}>Blooms</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.completed}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.BLOOMS?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                           <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder',bgcolor: "#7a7d52"}}>MM</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.completed}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.MM?.pending}</TableCell>
                        </TableRow>
                        <TableRow>
                           <TableCell className='text-light text-center py-4' sx={{fontSize:'20px', fontWeight:'bolder', bgcolor: "#7a7d52"}}>Transport</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.totalJobs}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.allocated}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.pendingApproval}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.orphan}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.completed}</TableCell>
                            <TableCell className='text-center' sx={{fontSize:'20px', fontWeight:'bolder'}}>{allocationPoints?.TRANSPORT?.pending}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
            <Box className='mt-5 mx-2 pt-3'>
                <Typography className='text-center' variant='h4'>Pending Allocations</Typography>
                <Table className='mt-3' sx={{ borderRadius: '10px' }}>
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell sx={{ color: "white", fontWeight: 'bold' }}>Venue Name</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign:'center' }}>Group Name</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign:'center' }}>Hotel Type</TableCell>
                            <TableCell sx={{ color: "white", fontWeight: 'bold', textAlign:'center' }}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            allocationTable.length > 0 ? (allocationTable?.map((item:any, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item?.venueId?.venueName}</TableCell>
                                    <TableCell sx={{textAlign:'center'}}>{item?.allocationClientGroup}</TableCell>
                                    <TableCell sx={{textAlign:'center'}}>{item?.venueId?.shopTypeId?.shopTypeName}</TableCell>
                                    <TableCell sx={{textAlign:'center'}}>{Status()}</TableCell>
                                </TableRow>

                            ))) : <TableCell colSpan={4} className='text-center'><Typography>No Data Found</Typography></TableCell>
                        }
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
        </div>

    )
}

export default ImportExportAllocations
